import Vue from 'vue';
import router from '../../../ugsrc/router/index';
import { EventBus } from '../../../common/assets/utils/eventBus';

export const tenantDetails = {
    namespaced: true,
    state: {
        allTenants: [],
    },
    getters: {
      
    },
    actions: {
        getAllTenantsData({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            Vue.http.get('/tenants/')
			.then((res) => {
                commit('saveAllTenantsData', res.data);
                EventBus.$emit('showLoadingIcon', false);
			}, (error) => {
                commit('saveAllTenantsData', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
			})
        },
        syncTenantsData({state}, data){
            if(state.allTenants.length > 0){
                if(data.from == 'tenantsPage'){
                    if(data.updateTenant){
                        state.allTenants[data.updatedTenantIndex] = data.tenantInfo;
                    } else {
                        state.allTenants.push(data.tenantInfo);
                    }
                } else{
                    const switchedTenantIndex = state.allTenants.findIndex((tenant) => tenant.domain == data.tenantDomain);
                    if(data.from == 'appsPage'){
                        if(state.allTenants[switchedTenantIndex]['num_apps']){
                            state.allTenants[switchedTenantIndex]['num_apps']++; 
                        } else {
                            state.allTenants[switchedTenantIndex]['num_apps'] = 1; 
                        }
                    } else if(data.from == 'usersPage'){
                        if(data.userDeleted){
                            if(state.allTenants[switchedTenantIndex]['num_users'] > 0){
                                state.allTenants[switchedTenantIndex]['num_users']--; 
                            } else {
                                state.allTenants[switchedTenantIndex]['num_users'] = 0; 
                            }
                        } else {
                            if(state.allTenants[switchedTenantIndex]['num_users'] > 0){
                                state.allTenants[switchedTenantIndex]['num_users']++; 
                            } else {
                                state.allTenants[switchedTenantIndex]['num_users'] = 1; 
                            }
                        }
                    }
                }
            }
        }
    },
    mutations: {
        saveAllTenantsData(state, tenantsData){
            let companies = [];
            try{
                for(var tenant in tenantsData){
                    tenantsData[tenant]['fields']['pk'] = tenantsData[tenant]['pk'];
                    tenantsData[tenant]['fields']['domain'] = tenantsData[tenant]['domain'];

                    // for Logo
                    if(tenantsData[tenant]['fields']['logo']){
                        tenantsData[tenant]['fields']['logo'] = tenantsData[tenant]['fields']['logo'];
                    }else if(tenantsData[tenant]['fields']['website']){
                        tenantsData[tenant]['fields']['logo'] = 'http://www.google.com/s2/favicons?domain='+tenantsData[tenant]['fields']['website'];
                    }else{
                        tenantsData[tenant]['fields']['logo'] = null;
                    }

                    tenantsData[tenant]['fields']['2fa_enabled'] = tenantsData[tenant]['fields']['two_factor_authenticate'];
                    companies.push(tenantsData[tenant]['fields']);
                }
            }
            catch(err){
                console.log("error is:",err);
            }
            state.allTenants = companies;
        },
    },
  };
  